export default "__VITE_ASSET__Dlt1bYl5__"